<template>
  <form
    @submit.prevent="handleSubmit"
    name="personal"
    class="clearfix">
    <div class="col-md-6 padding-off mt-5">
      <!-- Subtitulo -->
      <div class="col-md-12">
        <h4 class="title-manage-account">Dados pessoais</h4>
      </div>
      <!-- /Subtitulo -->
      <div class="col-md-12">
        <!-- Nome completo -->
        <input-field
          :submitted="submitted"
          :field.sync="form.full_name"
          :required="true"
          label="Nome completo"
          type="text"
          name="full_name"
          validate="required|alpha_spaces|min:2"></input-field>
        <!-- / Nome completo -->
      </div>
      <div class="col-md-6">
        <!-- E-mail -->
        <input-field
          :submitted="submitted"
          :field.sync="form.email"
          :required="true"
          label="E-mail"
          type="text"
          name="email"
          validate="required|email"></input-field>
        <!-- / E-mail -->
      </div>
      <div class="col-md-6">
        <!-- E-mail Secundário -->
        <input-field
          :field.sync="form.additional_email"
          label="E-mail Adicional"
          type="text"
          name="additional_email"
          validate="email"></input-field>
        <!-- /E-mail Secundário -->
      </div>
      <div class="col-md-12 padding-off">
        <div class="col-md-6">
          <!-- CPF -->
          <input-field
            :submitted="submitted"
            :field.sync="form.document_number"
            :required="true"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            label="CPF"
            type="text"
            name="document_number"
            validate="required"></input-field>
          <!-- / CPF -->
        </div>
        <div class="col-md-6">
          <!-- Data de Nascimento -->
          <input-field
            :submitted="submitted"
            :field.sync="form.birth_date"
            :required="true"
            :mask="['##/##/####']"
            label="Data de Nascimento"
            type="tel"
            name="birth_date"
            validate="required"></input-field>
          <!-- / Data de Nascimento -->
        </div>
      </div>
      <div class="col-md-12 padding-off">
        <div class="col-md-6">
          <!-- Telefone fixo -->
          <input-field
            :submitted="submitted"
            :field.sync="form.phone"
            :required="true"
            :mask="['(##) ####-####', '(##) #####-####']"
            label="Telefone"
            type="tel"
            name="phone"
            validate="required"></input-field>
          <!-- / Telefone fixo -->
        </div>
        <div class="col-md-6">
          <!-- Telefone celular -->
          <input-field
            :submitted="submitted"
            :field.sync="form.mobile_phone"
            :required="true"
            :mask="['(##) ####-####', '(##) #####-####']"
            label="Celular"
            type="tel"
            name="mobile_phone"
            validate="required"></input-field>
          <!-- / Telefone celular -->
        </div>
      </div>
      <div class="col-md-12">
        <!-- Gênero -->
        <radio-field
          :submitted="submitted"
          :field.sync="form.gender"
          :required="true"
          :options="options.gender"
          label="Gênero"
          name="gender"
          validate="required|included:1,2"></radio-field>
        <!-- / Gênero -->
      </div>
    </div>

    <div class="col-md-6 padding-off mt-5">
      <address-form
        title="Endereço Residencial"
        :submitted="submitted"
        :form.sync="form.address"></address-form>
    </div>

    <div class="col-sm-12 mb-5 clearfix">
      <small>*Campos obrigatórios</small>
    </div>
    <div class="col-sm-12 mb-20 padding-off">
      <!-- Parent Action -->
      <slot :handleParentAction="() => $emit('handleParentAction')"></slot>
      <!-- // Parent Action -->
      <div class="col-xs-6">
        <button
          :disabled="disabled"
          type="submit"
          class="btn-blue btn-block btn-extra-large">
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import InputField from '@/components/fields/InputField'
import RadioField from '@/components/fields/RadioField'
import AddressForm from '@/components/forms/AddressForm'

export default {
  components: {
    InputField,
    RadioField,
    AddressForm
  },
  data: function() {
    return {
      form: {
        id: null,
        full_name: null,
        document_number: null,
        birth_date: null,
        genero: null,
        mobile_phone: null,
        phone: null,
        email: null,
        additional_email: null,
        frequency_purchases: null,
        buy_flights: null,
        buy_hotels: null,
        rent_cars: null,
        address: {
          street: null,
          number: null,
          complement: null,
          neighborhood: null,
          city: null,
          province: null,
          country: null,
          zip_code: null
        }
      },
      submitted: false,
      disabled: false,
      /**/
      options: {
        gender: [
          { value: 1, label: 'Masculino' },
          { value: 2, label: 'Feminino' }
        ]
      }
    }
  },
  mounted () {
    this.getPersonalAccount()
  },
  computed: {
    ...mapState('personal', ['results', 'alert'])
  },
  watch: {
    results (data) {
      this.form = data
    }
  },
  methods: {
    ...mapActions('personal', [
      'getPersonalAccount',
      'postPersonalAccount'
    ]),
    handleSubmit () {
      this.$validator.validate().then(valid => {
        this.submitted = true

        if (valid) {
          this.disabled = true
          this.postPersonalAccount(this.form)
            .then(this.handleParent)
            .catch(this.handleParent)
        }
      }).catch(() => {
        /**/
        this.submitted = false
      })
    },
    handleParent () {
      if (this.$listeners && this.$listeners.handleParentAction) {
        this.$emit('handleParentAction')
      }
      this.disabled = false
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/components/forms/ScopedForms';
</style>
